import React from "react";
import {ImageWrapper} from './styles';
import {Column} from './styles';
import {ColumnWrapper} from './styles';

import {Container, Title, TitleWrapper} from "./styles";

export const ColumnPhoto = ({data, color}) => {
  return (
    <Container color={color}>
      {data.title && (
        <TitleWrapper>
          <Title>{data.title}</Title>
        </TitleWrapper>
      )}

      <ColumnWrapper>
        <Column>
          <ImageWrapper width={data.img1.width}>
            {data.img1.image}
          </ImageWrapper>
        </Column>
        {data.img2 && (
          <Column>
            <ImageWrapper width={data.img2.width}>
              {data.img2.image}
            </ImageWrapper>
          </Column>
        )}
      </ColumnWrapper>
    </Container>
  );
};
